import { render, staticRenderFns } from "./EducationCompliance.vue?vue&type=template&id=6c57ae62&scoped=true&"
import script from "./EducationCompliance.vue?vue&type=script&lang=js&"
export * from "./EducationCompliance.vue?vue&type=script&lang=js&"
import style0 from "./EducationCompliance.vue?vue&type=style&index=0&id=6c57ae62&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c57ae62",
  null
  
)

export default component.exports